// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const FooterChat: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 14 11">
            <path
                fill="currentColor"
                d="M9.1 3.781c0 2.089-2.037 3.781-4.55 3.781a5.255 5.255 0 0 1-2.185-.464L0 7.563l.823-1.614C.304 5.335 0 4.587 0 3.781 0 1.693 2.037 0 4.55 0S9.1 1.693 9.1 3.781zm.7 0a4.1 4.1 0 0 0-.013-.333C12.143 3.59 14 5.225 14 7.218c0 .806-.304 1.554-.822 2.169L14 11l-2.365-.464A5.255 5.255 0 0 1 9.45 11c-2.091 0-3.854-1.173-4.386-2.771C7.632 8.012 9.8 6.194 9.8 3.78z"
            />
        </svg>
    );
};

export default React.memo(FooterChat);
